/* eslint-disable camelcase */
import React, { useEffect, useMemo } from "react";
import { Spin } from "antd";
import { useSearchParams } from "react-router";
import { AxiosError } from "axios";
import { useAuthSSO } from "@companion-core/shared/app/Queries/auth";
import { trackConsentPage, trackClickConsent } from "@companion-core/shared/app/tracking/sso";
import "@companion-core/web/src/Assets/Styles/scss/ssoPartnerConsent.scss";

export const SSOPartnerConsent = () => {
  const [searchParams] = useSearchParams();
  const client_id = useMemo(() => searchParams.get("client_id") ?? "", [searchParams]);
  const response_type = useMemo(() => searchParams.get("response_type") ?? "", [searchParams]);
  const redirect_uri = useMemo(() => searchParams.get("redirect_uri") ?? "", [searchParams]);
  const state = useMemo(() => searchParams.get("state") ?? "", [searchParams]);
  const scope = useMemo(() => searchParams.get("scope") ?? "", [searchParams]);
  const code_challenge = useMemo(() => searchParams.get("code_challenge") ?? "", [searchParams]);
  const code_challenge_method = useMemo(
    () => searchParams.get("code_challenge_method") ?? "",
    [searchParams],
  );
  const { mutateAsync: sendSSORequest } = useAuthSSO();

  useEffect(() => {
    trackConsentPage();
    sendConsent();
  }, []);

  const sendConsent = async (): Promise<void> => {
    try {
      trackClickConsent(true);
      const response = await sendSSORequest({
        client_id,
        response_type,
        redirect_uri,
        state,
        scope,
        code_challenge,
        code_challenge_method,
      });
      window.open(response.data.redirect_uri, "_self");
    } catch (e) {
      let error_status = "unsupported_response_type";
      switch ((e as AxiosError)?.response?.status) {
        case 400:
        case 401:
          error_status = "invalid_request";
          break;
        case 500:
          error_status = "server_error";
          break;
        case 503:
          error_status = "temporary_unavalaible";
          break;
        default:
          break;
      }
      window.open(
        `${redirect_uri}?error=${error_status}${state ? `&state=${state}` : ""}`,
        "_self",
      );
    }
  };

  return <Spin className="sso-consent__spin" size="large" />;
};
